import {createContext, PointerEventHandler} from 'react';

const EmergencyContext = createContext(
  {} as { emergencyOnPointerDownHandler: PointerEventHandler<any> }
);

export default EmergencyContext;
